import allCities from '@app/data/cities.json';
export function searchCityByName(city: string, state: string) {
  const query = normalize(city);

  const exactly = allCities.filter((city) => {
    if (state && city.Sigla_UF !== state) {
      return false;
    }
    return query === normalize(city.Nom_Cidade);
  });

  if (exactly.length == 0) {
    const aproximated = allCities.filter((city) => {
      if (state && city.Sigla_UF !== state) {
        return false;
      }
      return normalize(city.Nom_Cidade).includes(query);
    });

    return aproximated;
  }

  return exactly;
}

function normalize(text: string) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}